import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IDtpSearch, IDtpDetail, IDtpInsert, IDtpUpdate, ISupplierOfferSearch, ISupplierOfferDetails, ISupplierOfferInsert, ISupplierOfferUpdate } from "./dtpTypes";



class DtpService {
    async page(searchVo: IDtpSearch, config: object = {}) {
        const apiUrl = "/gtm/inquiry/listPage";
        return await httpRequest.post<IPage<IDtpDetail>>(apiUrl, searchVo, config);
    }
    async insert(insertVo: IDtpInsert) {
        const apiUrl = "/gtm/inquiry/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IDtpUpdate) {
        const apiUrl = "/gtm/inquiry/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    async one(id: string) {
        const apiUrl = `/gtm/inquiry/findByIdOrCode/${id}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }
    //转报价合同
    async transferQuottion(id: string) {
        const apiUrl = ` /gtm/inquiry/transfer/${id}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }
    //作废
    async disable(id: string) {
        const apiUrl = `/gtm/inquiry/disable/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //列表导出
    async export(searchVo: IDtpSearch) {
        const appPageUrl = "/gtm/inquiry/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //明细导出
    async detailExport(code: string, shopCode: string) {
        const appPageUrl = `/gtm/inquiry/exportDetails/${code}/${shopCode}`;
        return await httpRequest.getFile(appPageUrl);
    }

    //询价单明细模板下载
    async downloadTpl() {
        const appPageUrl = "/gtm/inquiry/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

    /**供应商报价 */
    async pageOffer(searchVo: ISupplierOfferSearch, config: object = {}) {
        const apiUrl = "/gtm/supplierOffer/listPage";
        return await httpRequest.post<IPage<ISupplierOfferDetails>>(apiUrl, searchVo, config);
    }
    async insertOffer(insertVo: ISupplierOfferInsert) {
        const apiUrl = "/gtm/supplierOffer/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async updateOffer(updateVo: ISupplierOfferUpdate) {
        const apiUrl = "/gtm/supplierOffer/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    async oneOffer(id: string) {
        const apiUrl = `/gtm/supplierOffer/findByIdOrCode/${id}`;
        return await httpRequest.get<ISupplierOfferDetails>(apiUrl);
    }
    async disableOffer(id: string) {
        const apiUrl = `/gtm/supplierOffer/disable/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //出口报价
    async transferOffer(vo: { "code": string, "shopCode": string }) {
        const apiUrl = "/gtm/supplierOffer/transfer";
        return await httpRequest.post<string>(apiUrl, vo);
    }
    //供应商报价明细导出
    async offerExport(HRcode: string, shopCode: string) {
        const appPageUrl = `/gtm/supplierOffer/exportDetails/${HRcode}/${shopCode}`;
        return await httpRequest.getFile(appPageUrl);
    }
    //供应商报价模板下载
    async offerDownloadTpl() {
        const appPageUrl = "/gtm/supplierOffer/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }



}

export const enquiryService = new DtpService();
